<template>
  <v-form @submit.prevent="save" novalidate>
    <pr-box :title="titleBox">

      <div slot="buttons-header">
        <v-btn icon @click.native="goToList">
          <v-icon color="white">list</v-icon>
        </v-btn>
      </div>

      <v-alert
        :value="showAlert"
        type="error">
        Não existem clientes cadastrados no sistema.
      </v-alert>

      <v-layout v-if="!showAlert" row>
        <v-flex xs12 md4>
          <v-select
            :items="clients"
            item-text="name"
            item-value="id"
            hint="Selecione um cliente para filtrar os ciclos"
            v-model="client"
            required
            return-object
            persistent-hint
            clearable
            :disabled="(clients.length === 0)"
            no-data-text="Nenhuma registro encontrado"
            :error-messages="validationErrors.client_id"
            label="Selecione um cliente"></v-select>
        </v-flex>
        <v-flex xs12 md2>
          <v-select
            :items="cycleStatusList"
            v-model="cycleStatus"
            item-text="description"
            item-value="value"
            clearable
            label="Status do Ciclo">
          </v-select>
        </v-flex>
      </v-layout>

      <v-layout v-if="!showAlert" row wrap>
        <v-flex xs12 md4>
          <v-select
            :items="cycles"
            v-model="resource.cycle_id"
            item-text="name"
            item-value="id"
            no-data-text="Nenhuma registro encontrado"
            required
            hint="Vincular um ciclo a este faturamento"
            label="Selecione um ciclo"
            persistent-hint
            :disabled="(!client && !cycleStatus) || cycles.length === 0"
            :error-messages="validationErrors.cycle_id">
            <template slot="selection" slot-scope="data">
              {{ data.item.name }}
            </template>
            <template slot="item" slot-scope="data">
              <template>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ data.item.name }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    <small>{{ data.item.start_date | prDate }} até {{ data.item.end_date | prDate }}</small>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field mask="####" label="Horas Executadas"
                        :disabled="!client && !cycleStatus"
                        v-model="resource.hours_performed" required
                        :error-messages="validationErrors.hours_performed">
          </v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field mask="####" label="Horas Faturadas"
                        :disabled="!client && !cycleStatus"
                        v-model="resource.billed_hours" required
                        :error-messages="validationErrors.billed_hours">
          </v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field label="Autorizado Por"
                        :disabled="!client && !cycleStatus"
                        v-model="resource.authorized_by" required
                        :error-messages="validationErrors.authorized_by">
          </v-text-field>
        </v-flex>
      </v-layout>

      <div v-if="!showAlert" slot="buttons-footer">
        <v-btn flat type="submit" color="primary" :disabled="!client && !cycleStatus" :loading="saveLoading">Salvar</v-btn>
      </div>
    </pr-box>
  </v-form>
</template>

<script>
import CrudMixin from '@/components/mixins/CrudMixin';
import BillingReportService from '@/features/billing-report/BillingReportService';
import CycleService from '@/features/cycle/CycleService';
import ClientService from '@/features/client/ClientService';

export default {
  name: 'billing-report-form',
  mixins: [CrudMixin],
  data() {
    return {
      loading: false,
      showAlert: false,
      cycleStatusList: [
        { id: 1, description: 'ATIVO', value: 'sim' },
        { id: 2, description: 'INATIVO', value: 'nao' },
      ],
      cycles: [],
      clients: [],
      cycleStatus: null,
      client: null,
      cycleService: new CycleService(),
      clientService: new ClientService(),
    };
  },
  watch: {
    client() {
      this.loadCycles();
    },
    cycleStatus() {
      this.loadCycles();
    },
  },
  mounted() {
    this.loadClient();
  },
  methods: {
    initCrud() {
      this.serviceType = BillingReportService;
      this.routerName = 'billing-report';
      this.componentType = 'FORM';
    },
    afterLoadResource() {
      this.resource.cycle_id = parseInt(this.resource.cycle_id, 10);
    },
    async loadCycles() {
      const filter = {};
      if (this.client) {
        filter.client_id = this.client.id;
      }
      if (this.cycleStatus) {
        filter.active = this.cycleStatus;
      }
      this.cycles = await this.cycleService.query(filter);
    },
    async loadClient() {
      this.clients = await this.clientService.query();
      if (this.clients.length === 0) this.showAlert = true;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/features/billing-report/BillingReportForm.vue